module.exports = __webpack_public_path__ + "img/SetraBlue_logo.4869f8db.jpg";